import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "isChatOpen", "isMenuOpen", "view", "isDesktop", "menuItemsCount", "className"];
import { AnimatePresence, motion } from 'framer-motion';
import React from 'react';
import { cnBem } from '@carnica/utils';
import styles from "./styles.pcss";
var variants = {
  /** @description функции для расчета высоты меню:
   * 96 - паддинги + заголовок
   * 64 - высота элемента
   * 4 - гэп между элементами
   */
  menu: function menu(_ref) {
    var isDesktop = _ref.isDesktop,
      menuItemsCount = _ref.menuItemsCount;
    return {
      height: isDesktop ? "".concat(96 + menuItemsCount * 64 + 4 * (menuItemsCount - 1), "px") : '100%'
    };
  },
  chat: function chat(_ref2) {
    var isDesktop = _ref2.isDesktop;
    return {
      height: isDesktop ? 'min(644px, calc(100dvh - 80px))' : '100%'
    };
  }
};
var cnChatWidget = cnBem('chat-widget', styles);
export var ChatWidgetContainer = function ChatWidgetContainer(props) {
  var children = props.children,
    isChatOpen = props.isChatOpen,
    isMenuOpen = props.isMenuOpen,
    view = props.view,
    _props$isDesktop = props.isDesktop,
    isDesktop = _props$isDesktop === void 0 ? true : _props$isDesktop,
    _props$menuItemsCount = props.menuItemsCount,
    menuItemsCount = _props$menuItemsCount === void 0 ? 1 : _props$menuItemsCount,
    className = props.className,
    otherProps = _objectWithoutProperties(props, _excluded);
  var open = isChatOpen || isMenuOpen;
  var isChatVisible = isChatOpen || menuItemsCount < 2;
  return /*#__PURE__*/React.createElement(AnimatePresence, {
    custom: open,
    initial: false,
    mode: "wait"
  }, /*#__PURE__*/React.createElement(motion.div, _extends({}, otherProps, {
    animate: isChatVisible ? 'chat' : 'menu',
    className: cnChatWidget('content', {
      view: view
    }),
    custom: {
      menuItemsCount: menuItemsCount,
      isDesktop: isDesktop
    },
    initial: "menu",
    style: _defineProperty(_defineProperty({}, '--chat-widget-height', variants.chat({
      isDesktop: isDesktop
    }).height), '--chat-menu-height', variants.menu({
      isDesktop: isDesktop,
      menuItemsCount: menuItemsCount
    }).height),
    variants: variants
  }), children));
};